const JavascriptUtilsTooling = {
  deepCopy: obj => {
    return JSON.parse(JSON.stringify(obj));
  },
  setObjectStringPathKeyValue: (obj, path,  value) => {
    if(!path || !obj) {
      return obj;
    }
    var splittedPath = path.split(".");

    if(splittedPath.length>1) {
      if(typeof obj[splittedPath[0]] == "undefined") {
        obj[splittedPath[0]] = {};
      }
      JavascriptUtilsTooling.setObjectStringPathKeyValue(
        obj[splittedPath[0]],
        splittedPath.slice(1).join("."),
        value
      );
    }
    else {
      obj[splittedPath[0]] = value;
    }
    return obj;
  },
  getObjectStringPathKeyValue: (obj, path, noValue = null) => {
    if(!path || !obj) {
      return noValue;
    }
    var splittedPath = path.split(".");

    if(splittedPath.length>1) {
      if(typeof obj[splittedPath[0]] == "undefined") {
        return noValue;
      }
      return JavascriptUtilsTooling.getObjectStringPathKeyValue(
        obj[splittedPath[0]],
        splittedPath.slice(1).join("."),
        noValue
      );
    }
    else {
      return obj[splittedPath[0]];
    }
  },
  getInputValueFromEvent: (event) => {
    return (event.currentTarget.type=="checkbox") ? event.currentTarget.checked : event.currentTarget.value;
  },
  getMouseCursorSideOnElement: (event) => {
    let target = event.currentTarget;
    let index = target.dataset.index;
    let onlyLeft = target.dataset.onlyleft;
    let posX = Math.max(0,event.clientX - target.getBoundingClientRect().left);
    let width = target.offsetWidth;
    let percentagePosition = posX/width;
    if(onlyLeft) {
      return -1;
    }
    return percentagePosition > 0.4 ? 1 : -1;
  }
};

export default JavascriptUtilsTooling;


// WEBPACK FOOTER //
// ./source/tooling/javascriptUtilsTooling.js